import * as React from "react";
import { Button } from "./Button";
import { Delete } from "baseui/icon";
import { useStyletron } from "kanopi-components/theme/useStyletron";

/* eslint-disable react/prop-types */
// TODO: Enable the proptype check next time when this file is changed

export function CloseButton({ title = "Close", ...restProps }) {
  const [, theme] = useStyletron();
  return (
    <Button
      type="button"
      shape={Button.SHAPE.circle}
      color={theme.colors.contentInverseTertiary}
      size={Button.SIZE.mini}
      name="close"
      {...restProps}
    >
      <Delete
        title={title}
        style={{ minWidth: "24px", fill: theme.colors.contentInversePrimary }}
      />
    </Button>
  );
}
